import React from "react";
import { ScheduleExceptionReportContainer } from "../../../containers";

const ScheduleExceptionReport = (props) => {
  return <ScheduleExceptionReportContainer {...props} />;
};

export default ScheduleExceptionReport;
